import { IMDSMenuProps } from "./menu.types";
import { StyledMenu } from "./menu.style";

export function MDSMenu(props: IMDSMenuProps) {
  return <StyledMenu data-mds-name="menu" {...props} />;
}
